// Reusable per-location visit-task catalog for Route Planning.
// mode 'work'  -> technician can Inspect & report / Perform approved work / Do both.
// mode 'observe' -> factual, report-only observation (no "perform"); kept neutral.
// Nothing is preselected; the dispatcher opts each task in per service location.

export const TASK_CATEGORIES = [
  {
    key: 'kitchen', label: 'Kitchen & breakroom', tasks: [
      { key: 'vault', label: 'Inspect / clean vault', mode: 'work' },
      { key: 'fridge', label: 'Clean refrigerator (inside & outside)', mode: 'work' },
      { key: 'microwave', label: 'Clean microwave (inside & outside)', mode: 'work' },
      { key: 'kitchen_sink', label: 'Detail-scrub kitchen sink', mode: 'work' },
    ],
  },
  {
    key: 'restrooms', label: 'Restrooms & high dusting', tasks: [
      { key: 'restroom_metal', label: 'Detail metalwork in restrooms', mode: 'work' },
      { key: 'ac_vents', label: 'Dust AC vents & high dusting', mode: 'work' },
      { key: 'cobwebs', label: 'Check for cobwebs', mode: 'work' },
    ],
  },
  {
    key: 'glass', label: 'Glass & entrance', tasks: [
      { key: 'entrance_mats', label: 'Inspect / clean entrance mats', mode: 'work' },
      { key: 'glass_int_ext', label: 'Inspect / clean interior & exterior glass', mode: 'work' },
      { key: 'entrance_glass', label: 'Inspect / clean entrance glass (inside & outside)', mode: 'work' },
      { key: 'drive_thru_glass', label: 'Inspect / clean drive-through & teller windows, ATMs & portable ATMs', mode: 'work' },
    ],
  },
  {
    key: 'exterior', label: 'Exterior & grounds', tasks: [
      { key: 'litter', label: 'Check entrance & adjacent sidewalks for litter', mode: 'work' },
      { key: 'sidewalk_pw', label: 'Inspect sidewalks for possible pressure washing', mode: 'work' },
      { key: 'landscaping', label: 'Inspect landscaping', mode: 'work' },
      { key: 'signage', label: 'Inspect building signage, ADA signage, stop signs & car stops', mode: 'work' },
      { key: 'ext_lighting', label: 'Inspect exterior lighting', mode: 'work' },
    ],
  },
  {
    key: 'equipment', label: 'Cleaning equipment & supplies', tasks: [
      { key: 'vacuum', label: 'Inspect / clean vacuum', mode: 'work' },
      { key: 'restock_chem', label: 'Restock chemicals', mode: 'work' },
      { key: 'chem_dispense', label: 'Check chemical dispensing system', mode: 'work' },
      { key: 'tools', label: 'Check / replace mop heads, brooms, dust pans, toilet brushes, dusters & rags', mode: 'work' },
      { key: 'equip_condition', label: 'Inspect condition of mop buckets, wringers, vacuums & other equipment', mode: 'work' },
    ],
  },
  {
    key: 'quality', label: 'Cleaning quality & flooring', tasks: [
      { key: 'overall_quality', label: 'Inspect overall cleaning quality (dust, hard floors, carpets)', mode: 'work' },
      { key: 'shampoo_carpet', label: 'Inspect / shampoo carpets', mode: 'work' },
      { key: 'vct', label: 'Inspect / strip & wax VCT flooring', mode: 'work' },
      { key: 'scrub_hard', label: 'Inspect / scrub hard floors', mode: 'work' },
    ],
  },
  {
    key: 'building', label: 'Building items', tasks: [
      { key: 'int_lighting', label: 'Inspect interior lighting; replace bulbs when approved', mode: 'work' },
      { key: 'tiles', label: 'Replace ceiling tiles or carpet tiles when approved', mode: 'work' },
    ],
  },
  {
    key: 'personnel', label: 'Personnel appearance & conduct (observation)', tasks: [
      { key: 'uniform', label: 'Uniform worn', mode: 'observe' },
      { key: 'closed_shoes', label: 'Closed-toe shoes', mode: 'observe' },
      { key: 'shorts', label: 'Shorts worn', mode: 'observe' },
      { key: 'family_present', label: 'Family members / underage children present', mode: 'observe' },
    ],
  },
];

export const ACTION_LABELS = {
  inspect: 'Inspect & report',
  perform: 'Perform approved work',
  both: 'Do both',
  observe: 'Observe & report',
};

const _modeByKey = {};
TASK_CATEGORIES.forEach(c => c.tasks.forEach(t => { _modeByKey[t.key] = t.mode; }));
export const taskMode = (key) => _modeByKey[key] || 'work';
